import React from 'react';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import Recommendations from '@app/components/Pages/Home/Recommendations';
import Background from '@app/components/UI/Background/Background';
import Card from '@app/components/UI/Card/Card';
import HelmetProvider from '@app/components/UI/Helmet/HelmetCustom';
import SelectedText from '@app/components/UI/SelectedText';
import '@app/scss/pages/petParents.scss';

const SymptomsOfPet: React.FC<{ className? }> = ({ className }) => {
	return (
		<div className={`white-box white-box-1 ${className || ''}`}>
			<h2>Symptoms of Pet Caregiver Burnout are:</h2>
			<ul>
				<li>Withdrawal from friends, family, and other loved ones</li>
				<li>Loss of interest in activities previously enjoyed</li>
				<li>Feeling blue, irritable, hopeless, and helpless</li>
				<li>Changes in appetite, weight, or both</li>
				<li>Changes in sleep patterns</li>
				<li>Getting sick more often</li>
				<li>Feelings of wanting to hurt yourself or the person for whom you are caring</li>
				<li>Emotional and physical exhaustion</li>
				<li>Irritability</li>
			</ul>
		</div>
	);
};

const PetParents: React.FC = () => {
	return (
		<HelmetProvider title="Pet Parents">
			<div className="pet-parents-page is-relative pages">
				<Background />
				<div className="container">
					<Card
						imageLeftSide={false}
						image={
							<>
								<img style={{ transform: 'translateX(-40px)' }} alt="pet-parents" src="/images/pet-parents-1.png" />
								<SymptomsOfPet className="show-mobile" />
							</>
						}
						text={
							<div>
								<h2 className="pet-parents-page__title">
									<span className="is-relative" style={{ zIndex: 3 }}>
										Pet
									</span>
									<SelectedText text=" Parents" />
								</h2>
								<div className="h4">
									Dr. Mary Gardner is not just a veterinarian; she's a compassionate advocate for both senior pets and their
									devoted families. With a deep understanding of the unique challenges that pet parents face while caring
									for older furry companions, she derives immense satisfaction from guiding families toward practical
									solutions that ensure their pets' comfort and safety. Dr. Mary is acutely aware of the emotional and
									physical toll that caregiver burden can bring, having experienced it firsthand. She empathizes with the
									heart-wrenching decision of when it's time to bid farewell to a cherished pet. Through a wealth of
									resources, including informative videos, insightful articles, engaging speaking engagements, and authored
									books, Dr. Mary Gardner is unwaveringly dedicated to supporting senior dogs and cats and the loving
									families that cherish them. Her mission is clear: to provide the guidance and compassion needed to enhance
									the quality of life for aging pets and their devoted caregivers.
								</div>
							</div>
						}
					/>
				</div>
				<div className="bg-white-opacity">
					<div className="container">
						<Card
							image={
								<>
									<div className="">
										<img className="back1" src="/images/back1.png" alt="" width={682} height={344} />
									</div>
									<h2>
										<SelectedText text="Caregiver " />
										burden
									</h2>
									<div className="h4">
										Pet caregiver burden refers to the emotional, physical, and sometimes financial strain experienced by
										individuals responsible for the care of aging, ill, or terminally ill pets. It encompasses the stress,
										worry, and exhaustion that can arise from managing a pet's complex medical needs, making difficult
										decisions about their well-being, and coping with the emotional toll of caring for a beloved animal
										companion during challenging times. This burden can be particularly challenging when pet owners are
										faced with the prospect of end-of-life care or the difficult decision of euthanasia for their pets.
									</div>
								</>
							}
							text={<SymptomsOfPet className="mobile-hidden" />}
						/>
						<Card
							className="second-card"
							image={
								<div className="white-box">
									<h2 className="is-relative">
										What can help?
										<ImageLazy alt="Buddy pen" src="/images/BuddyPen.png" className="dog-pen" />
									</h2>
									<ul>
										<li>
											<strong>Mastery: </strong>
											Pet parents need to feel empowered and knowledgeable. Educating
											them not only on the disease but also the ways to manage the symptoms is vital.
										</li>
										<li>
											<strong>Coping Strategies: </strong>
											Speaking to a counselor is something many would not even
											consider but they can be a massive resource for the families.
											<a className="link" href="https://www.caregiver.org/" target="_blank" rel="nofollow noreferrer">
												Caregiver.org
											</a>
											{' '}
											is a great reference site.
											<a
												className="link"
												href="https://www.petcaregiverburden.com/"
												target="_blank"
												rel="nofollow noreferrer"
											>
												Petcaregiverburden.org
											</a>
											{' '}
											is also a wonderful site.
										</li>
										<li>
											<strong>Social Support: </strong>
											There are many illness specific groups (locally and on social
											media) and recruit family and friends to help — it takes a village
											to care for a sick pet.
										</li>
										<li>
											<strong>Respite Care: </strong>
											This type of care is common place in human medicine
											and can be a massive help to a family. Veterinary technicians can play
											a huge role in this niche.
										</li>
									</ul>
								</div>
							}
							text={
								<>
									<div className="h3 text-center ">
										Caregivers often experience burnout for two primary reasons. Firstly, they tend to impose unrealistic
										expectations on themselves, viewing caregiving as their sole duty. Secondly, they struggle to identify
										the signs of burnout, eventually reaching a point where they can no longer operate effectively and may
										even experience health issues of their own.
									</div>
									<ImageLazy alt="" src="/images/Group 64.png" width={658} height={594} />
								</>
							}
						/>
					</div>
				</div>
				<Recommendations />
			</div>
		</HelmetProvider>
	);
};

export default PetParents;
